import { ContactListType } from "utils/interfaces";
import EmptyViewPopUp from "./EmptyViewPopUp";
import { LoadingDots } from "utils/loadingAnimation";
import UserCard from "./UserCardPopUp";

interface UserCardsListProps {
  userList: ContactListType[] | null;
  selectedUsers: ContactListType[];
  isLoadingData: boolean;
  primaryTags?: boolean;
  justDisplay?: boolean;
  selectAction: (user: ContactListType, action: "add" | "remove") => void;
}

const UserCardsList: React.FC<UserCardsListProps> = ({
  userList,
  selectedUsers,
  isLoadingData,
  primaryTags = true,
  justDisplay = false,
  selectAction,
}) => {

  return (
    <div className="w-full max-h-[80vh] grow shrink justify-start items-start gap-[5px] inline-flex overflow-y-auto pop-up-scrollbar">
      <div className="w-full h-full self-stretch flex-col justify-start items-start gap-4 inline-flex">
        {userList && userList.length > 0 ? (
          userList.map((contact: ContactListType, index: number) => (
            <UserCard
              key={index}
              user={contact}
              selectedUsers={selectedUsers}
              selectAction={selectAction}
              justDisplay={justDisplay}
              activatePrimaryTag={primaryTags}
            />
          ))
        ) : !isLoadingData ? (
          <EmptyViewPopUp />
        ) : (
          <div className="w-full h-[50vh] flex justify-center items-center">
            <LoadingDots bgColor="bg-neutral-300" />
          </div>
        )}
      </div>
    </div>
  );
};

export default UserCardsList;
